export const socials = [
    {
        id: 1,
        name: "Hamam",
        image: "/assets/images/banner-01.jpg",
    },
    {
        id: 2,
        name: "Tualet",
        image: "/assets/images/banner-02.jpg",
    },
    {
        id: 3,
        name: "Mətbəx",
        image: "/assets/images/banner-03.jpg",
    },
];